'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.cjs');
var fetch = require('node-fetch');
var MetaplexFile = require('./MetaplexFile.cjs');
var SdkError = require('../../errors/SdkError.cjs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var fetch__default = /*#__PURE__*/_interopDefaultLegacy(fetch);

/**
 * @group Modules
 */
class StorageClient {
  constructor() {
    _rollupPluginBabelHelpers.defineProperty(this, "_driver", null);
  }
  driver() {
    if (!this._driver) {
      throw new SdkError.DriverNotProvidedError('StorageDriver');
    }
    return this._driver;
  }
  setDriver(newDriver) {
    this._driver = newDriver;
  }
  getUploadPriceForBytes(bytes) {
    return this.driver().getUploadPrice(bytes);
  }
  getUploadPriceForFile(file) {
    return this.getUploadPriceForFiles([file]);
  }
  getUploadPriceForFiles(files) {
    const driver = this.driver();
    return driver.getUploadPriceForFiles ? driver.getUploadPriceForFiles(files) : this.getUploadPriceForBytes(MetaplexFile.getBytesFromMetaplexFiles(...files));
  }
  upload(file) {
    return this.driver().upload(file);
  }
  uploadAll(files) {
    const driver = this.driver();
    return driver.uploadAll ? driver.uploadAll(files) : Promise.all(files.map(file => this.driver().upload(file)));
  }
  uploadJson(json) {
    return this.upload(MetaplexFile.toMetaplexFileFromJson(json));
  }
  async download(uri, options) {
    const driver = this.driver();
    if (driver.download) {
      return driver.download(uri, options);
    }
    const response = await fetch__default["default"](uri, options);
    const buffer = await response.arrayBuffer();
    return MetaplexFile.toMetaplexFile(buffer, uri);
  }
  async downloadJson(uri, options) {
    const file = await this.download(uri, options);
    try {
      return JSON.parse(file.buffer.toString());
    } catch (error) {
      throw new SdkError.InvalidJsonStringError(error);
    }
  }
}

exports.StorageClient = StorageClient;
//# sourceMappingURL=StorageClient.cjs.map
